import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Camera, Check } from "@phosphor-icons/react";

export const Placeholder = ({ label, className = "", tone = "bg-[#F6D5DA] text-[#9B2335]" }) => (
  <div className={`flex flex-col items-center justify-center gap-2 text-center text-xs px-4 ${tone} ${className}`} data-testid="photo-placeholder">
    <Camera size={18} /><span>[Photo: {label}]</span></div>
);

export const Chip = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-1.5 rounded-full bg-[#FBE3E6] text-[#B51F33] text-xs font-bold px-3 py-1 ${className}`}>{children}</span>
);

function JoinForm() {
  const nav = useNavigate();
  const [mode, setMode] = useState("whatsapp");
  const [value, setValue] = useState("");
  const join = (e) => {
    e.preventDefault();
    if (mode === "whatsapp") {
      const phone = value.replace(/[^\d+]/g, "");
      if (phone && /^\+?\d{9,15}$/.test(phone)) localStorage.setItem("bsafe_phone", JSON.stringify({ phone, at: Date.now() }));
      nav("/sign-up");
    }
    else nav(`/sign-up${value.trim() ? `?email=${encodeURIComponent(value.trim())}` : ""}`);
  };
  return (
    <form onSubmit={join} className="mt-8 bg-[#F2F4F8] rounded-2xl p-1.5 max-w-md" data-testid="hero-join-form">
      <div className="grid grid-cols-2 gap-1 mb-1.5">
        {[["whatsapp", "WhatsApp"], ["email", "Email"]].map(([k, l]) => (
          <button type="button" key={k} onClick={() => { setMode(k); setValue(""); }} data-testid={`join-mode-${k}`}
            className={`py-2 rounded-xl text-sm font-semibold transition-colors ${mode === k ? "bg-white text-[#16294A] shadow-sm" : "text-slate-500"}`}>{l}</button>))}
      </div>
      <div className="flex gap-1.5">
        <input data-testid="join-input" value={value} onChange={(e) => setValue(e.target.value)} type={mode === "email" ? "email" : "tel"}
          placeholder={mode === "email" ? "you@example.com" : "+256 7XX XXX XXX"} aria-label={mode === "email" ? "Email" : "WhatsApp number"}
          className="flex-1 min-w-0 bg-white rounded-xl px-4 py-3 text-sm text-[#16294A] outline-none focus:ring-2 focus:ring-[#D7263D]/40" />
        <button type="submit" data-testid="join-free-btn" className="rounded-xl bg-[#D7263D] hover:bg-[#B51F33] text-white font-bold text-sm px-6 transition-colors">Join free</button>
      </div>
    </form>
  );
}

const BentoCards = () => (
  <div className="grid grid-cols-2 gap-3 sm:gap-4">
    <div className="row-span-2 rounded-3xl border border-slate-200 bg-white p-4 flex flex-col gap-3 justify-center">
      <img src="/landing/wide_orange.webp" alt="Orange bsafe wide band" className="w-full -rotate-3 drop-shadow-lg" />
      <img src="/landing/wide_sky.webp" alt="Sky blue bsafe wide band" className="w-full rotate-2 drop-shadow-lg" />
      <div className="mt-2 flex items-center gap-3 rounded-xl bg-[#F2F4F8] p-3" data-testid="hero-alert-notice">
        <span className="w-8 h-8 shrink-0 rounded-lg bg-[#14352A] text-white flex items-center justify-center"><Check size={16} weight="bold" /></span>
        <div><div className="text-xs font-bold text-[#16294A]">Profile opened by a responder</div><div className="text-[11px] text-slate-500">Family alerted · [time]</div></div>
      </div>
    </div>
    <div className="relative rounded-3xl overflow-hidden min-h-[180px]" data-testid="hero-photo">
      <img src="/landing/photo_responder.webp" alt="Health worker checking a bsafe profile on a phone" className="absolute inset-0 w-full h-full object-cover" />
    </div>
    <div className="relative rounded-3xl bg-[#D6E2F3] p-4 flex items-center justify-center min-h-[180px] overflow-hidden">
      <span className="absolute top-3 right-3 rounded-full bg-[#D7263D] text-white text-[10px] font-extrabold px-2.5 py-1">NFC + QR</span>
      <img src="/landing/card_navy.webp" alt="Navy bsafe wallet card" className="w-[88%] rounded-xl shadow-xl -rotate-6" />
    </div>
  </div>
);

export default function Hero() {
  return (
    <section className="relative overflow-hidden" data-testid="landing-hero">
    <div className="absolute -top-40 -right-40 w-[560px] h-[560px] rounded-full bg-[#FCE4E7] blur-3xl opacity-60 pointer-events-none" />
    <div className="relative max-w-[1200px] mx-auto px-5 sm:px-8 pt-10 pb-20 grid lg:grid-cols-2 gap-12 items-center">
      <div className="fade-up">
        <Chip><span className="w-1.5 h-1.5 rounded-full bg-[#D7263D]" />Every second counts</Chip>
        <h1 className="mt-5 text-5xl sm:text-6xl font-extrabold leading-[1.02] tracking-tight text-[#16294A]">When you can't speak, <span className="text-[#D7263D]">your band can.</span></h1>
        <p className="mt-6 text-base text-slate-600 max-w-md">One tap or scan shows responders your blood group, allergies and who to call, and tells your family straight away.</p>
        <JoinForm />
        <div className="mt-4 flex flex-wrap gap-x-4 gap-y-1 text-xs font-semibold text-slate-600">
          {["Free profile", "Works on any phone", "NFC + QR", "Made in Kampala"].map((t, i) => <span key={t}><span className={i === 0 ? "text-[#D7263D]" : ""}>✓</span> {t}</span>)}
        </div>
      </div>
      <BentoCards />
    </div>
    </section>
  );
}
